import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Barbell, ArrowRight, Spinner, EnvelopeSimple, CheckCircle } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something went wrong");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] px-6 py-12">
      <div className="w-full max-w-md" data-testid="forgot-password-page">
        <Link to="/login" className="flex items-center gap-2 mb-12">
          <Barbell size={28} weight="fill" color="#FF3B30" />
          <span className="font-head text-2xl font-extrabold uppercase tracking-tight">Athlete<span className="text-[#FF3B30]">Hub</span></span>
        </Link>

        {sent ? (
          <div data-testid="forgot-password-success">
            <div className="w-14 h-14 rounded-sm bg-[#34C759]/15 flex items-center justify-center mb-6">
              <CheckCircle size={30} weight="fill" color="#34C759" />
            </div>
            <h1 className="font-head text-4xl font-black uppercase tracking-tighter leading-none mb-3">Check your inbox</h1>
            <p className="text-[#A3A3A3] mb-8">If an account exists for <span className="text-white font-semibold">{email}</span>, we've sent a secure link to reset your password. The link expires in 1 hour.</p>
            <Link to="/login" data-testid="back-to-login-link"
              className="inline-flex items-center gap-2 text-[#FF3B30] font-bold uppercase tracking-widest text-sm hover:text-[#FF5C53] transition-colors">
              Back to sign in <ArrowRight size={16} weight="bold" />
            </Link>
          </div>
        ) : (
          <>
            <h1 className="font-head text-4xl md:text-5xl font-black uppercase tracking-tighter leading-none mb-2">Forgot password?</h1>
            <p className="text-[#A3A3A3] mb-10">Enter your email and we'll send you a link to reset it.</p>
            <form onSubmit={submit} className="space-y-5">
              <div>
                <label className="block text-xs uppercase tracking-[0.2em] text-[#737373] font-semibold mb-2">Email</label>
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email-input"
                  className="w-full bg-[#0A0A0A] border border-white/20 text-white focus:border-[#FF3B30] focus:ring-1 focus:ring-[#FF3B30] rounded-sm p-4 placeholder-gray-600 outline-none transition-colors" placeholder="you@athletehub.com" />
              </div>
              <button type="submit" disabled={loading} data-testid="forgot-submit-button"
                className="w-full flex items-center justify-center gap-2 bg-[#FF3B30] hover:bg-[#FF5C53] disabled:opacity-60 text-white font-bold uppercase tracking-widest px-8 py-4 rounded-sm transition-colors">
                {loading ? <Spinner size={20} className="animate-spin" /> : <><EnvelopeSimple size={18} weight="bold" /> Send reset link</>}
              </button>
            </form>
            <Link to="/login" data-testid="back-to-login-link" className="inline-block mt-8 text-sm text-[#737373] hover:text-white transition-colors">← Back to sign in</Link>
          </>
        )}
      </div>
    </div>
  );
}
